import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { Order } from '../../../../overview/models/order';

@Injectable({
  providedIn: 'root'
})
export class OrderDetailsService {
  constructor(private http: HttpClient) {}

  getOrderBy(orderId: string, isArchived: boolean) {
    const url = isArchived ? 'archive/purchaseOrders' : 'purchaseOrders';
    return this.http.get<Order>(`${environment.apiUrl}/${url}/${orderId}`);
  }

  watched(orderId: string, watched: boolean) {
    return this.http.put(`${environment.apiUrl}/purchaseOrders/${orderId}/watched`, { watched });
  }
}
